import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText';

function Icon({ iconType, iconName, className }) {
  const registeredIcons = {
    'fal-envelope-open-text': faEnvelopeOpenText,
  };
  return (
    <FontAwesomeIcon
      icon={registeredIcons?.[`${iconType}-${iconName}`]}
      className={className}
    />
  );
}

export default React.memo(Icon);
